import { render, staticRenderFns } from "./Webpage.vue?vue&type=template&id=a4a766ea&scoped=true&"
import script from "./Webpage.vue?vue&type=script&lang=js&"
export * from "./Webpage.vue?vue&type=script&lang=js&"
import style0 from "./Webpage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Webpage.vue?vue&type=style&index=1&id=a4a766ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a766ea",
  null
  
)

export default component.exports